import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import App from '../App';
import Portfolio from './Portfolio/Portfolio';
import Videos from './Portfolio/video';
import Contact from './Contact';
import Sitemap from './Sitemap';
import NotFound from './NotFound';
import Header from './Header/Header';

const Router = () => (
  <div>
    <Header />
    <BrowserRouter >
      <Switch>
        <Route exact path="/" component={App} />
        <Route exact path="/portfolio" component={Portfolio} />
        <Route exact path="/videos" component={Videos} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/sitemap" component={Sitemap} />
        <Route component={NotFound} />
      </Switch>
    </BrowserRouter>
  </div>
);

export default Router;



// WEBPACK FOOTER //
// ./src/components/router.js